import { render } from "./ImportMasterDataView.vue?vue&type=template&id=65179c5c&scoped=true"
import script from "./ImportMasterDataView.vue?vue&type=script&lang=js"
export * from "./ImportMasterDataView.vue?vue&type=script&lang=js"

import "./ImportMasterDataView.vue?vue&type=style&index=0&id=65179c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65179c5c"]])

export default __exports__